export enum Colors {
  DefaultStarColor = '#f4d926',
  DefaultStarBgColor = '#eeeeee',
  StarColor = '#F0B501',
  StarBgColor = '#FFEEB9',
  GreyD = '#ddd',
}
